module.exports = __webpack_public_path__ + "media/demo.9a8ae66d.mp4";